import { render, staticRenderFns } from "./propertyManagement.vue?vue&type=template&id=9099196c"
import script from "./propertyManagement.vue?vue&type=script&lang=js"
export * from "./propertyManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports